/**
 * this file contains all redux-saga watchers & workers for the documents
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Min on 21/08/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'

// import action creators
import * as BillingActions from '../actions/billingActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF BILLING DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the billing data
export function* watchFetchBillingData() {
    yield takeEvery(C.FETCH_BILLING_DATA, workerFetchBillingData)
}

// worker saga for fetching biling data
function* workerFetchBillingData() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.billingFetchURL

    try {

        // show the loader
        yield put(BillingActions.showBillingLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data.data)) {
            const billingDetails = response.data.data.payment
            yield put(BillingActions.setBillingData(billingDetails))
        }

    } catch (error) {
        // set the success flag to false
        yield put(BillingActions.setBillingFetchSuccess(false))


    } finally {
        // hide the loader regardless
        yield put(BillingActions.showBillingLoader(false))
    }
}



// WEBPACK FOOTER //
// ./src/sagas/billingSaga.js